<template>
  <b-container fluid class="pb-4">
    <h1 class="fc-h1">{{ $i18n.t("usermente.title_edit") }}</h1>
    <form>
      <!-- 編集 -->
      <b-card :title="this.$i18n.t('usermente.label_edit')" class="w-50">
            <b-form-group
              id="mailAddressForm"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('usermente.label_mailaddress')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="mailAddressForm" disabled=true :placeholder="this.$i18n.t('usermente.placeholder_mailaddress')"></b-form-input>
            </b-form-group>
            <b-form-group
              id="opNameForm"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('usermente.label_user_name_mandatory')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="opNameForm" :placeholder="this.$i18n.t('usermente.placeholder_user_name')" maxlength="40">></b-form-input>
            </b-form-group>
            <b-form-group
              id="registerdGroupList"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('usermente.label_group')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="registerdGroupList" disabled=true :options="options" multiple :select-size="5" v-on:change="getSelectedGroup" ></b-form-select>
            </b-form-group>
            <div>
              <b-button variant="primary" @click="back" class="float-left px-5">{{ $i18n.t("usermente.label_back") }}</b-button>
            </div>
            <div>
              <b-button variant="primary" @click="regist" class="float-right px-5">{{ $i18n.t("usermente.button_update") }}</b-button>
            </div>
      </b-card>
    </form>
    <confirm-modal modId="md-confirm" :msg="this.$i18n.t('usermente.info_update')" :titleMsg="this.$i18n.t('usermente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="registConfirm"/>
    <confirmModal modId="md-err" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errConfirm"/>
  </b-container>
</template>

<script>
import confirmModal from './ConfirmModal'

export default {
  created () {
    // 所属グループ取得
    var reqObj = {}
    var headers = {
      'Content-Type': 'application/json',
      'opid': this.$store.store.state.opId,
      'ticketid': this.$store.store.state.ticketId
    }
    document.body.style.overflow = 'hidden'
    this.$store.store.state.loading = true
    this.$axios
      .post(window.END_POINT + '/master/group/select', reqObj, {
        'headers': headers
      })
      .then(res => {
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        if (res.data.result !== 'OK') {
          if (res.data.result === '401') {
            // ログインしていない場合
            this.$router.push('/')
          } else {
            this.errSbj = this.$i18n.t('common.title_modal_error')
            this.errMsg = this.$i18n.t(res.data.message)
            this.$bvModal.show('md-err')
          }
        } else {
          var selectedGroups = res.data.group
          var groups = []
          if (selectedGroups.length === 0) {
            this.errSbj = this.$i18n.t('common.title_modal_error')
            this.errMsg = this.$i18n.t('usermente.err_not_data')
            this.$bvModal.show('md-err')
            return
          }

          // 整形
          for (var i = 0; i < selectedGroups.length; i++) {
            var group = {}
            group.value = selectedGroups[i].group_id
            group.text = selectedGroups[i].group_name
            groups.push(group)
          }
          // 一旦データクリア
          this.options.splice(0)
          // データセット
          this.options.splice(0, 0, ...groups)

          // フォーム値セット
          this.opId = this.$store.store.state.opIdForm
          this.mailAddressForm = this.$store.store.state.mailAddress
          this.opNameForm = this.$store.store.state.opName
          this.registerdGroupList = this.$store.store.state.groupId
          this.selectedGroups = this.$store.store.state.groupId
          console.log(this.from)

          // 検索条件セット
          this.searchOpId = this.$store.store.state.searchOpId
          this.searchMailAddress = this.$store.store.state.searchMailAddress
          this.searchOpName = this.$store.store.state.searchOpName
        }
      })
      .catch(err => {
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        console.log(err)
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('common.unexpected_error')
        this.$bvModal.show('md-err')
      })
  },
  components: {
    confirmModal
  },
  data () {
    return {
      opId: null,
      mailAddressForm: null,
      opNameForm: null,
      searchOpId: null,
      searchMailAddress: null,
      searchOpName: null,
      registerdGroupList: null,
      selectedGroups: [],
      currentPage: 1,
      perPage: 5,
      options: [],
      tableVariants: [
        'primary',
        'secondary',
        'info',
        'danger',
        'warning',
        'success',
        'light',
        'dark'
      ],
      striped: true,
      bordered: true,
      borderless: true,
      outlined: false,
      small: false,
      hover: true,
      dark: true,
      fixed: true,
      footClone: false,
      headVariant: 'dark',
      tableVariant: '',
      noCollapse: true,
      errMsg: null,
      errSbj: null
    }
  },
  methods: {
    regist: function () {
      // 入力値チェック
      if (this.opNameForm === null || this.opNameForm === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('usermente.err_user_name_hissu')
        this.$bvModal.show('md-err')
        return
      }
      if (!window.checkProhibitedLetters(this.opNameForm)) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('usermente.err_user_name_symbol')
        this.$bvModal.show('md-err')
        return
      }

      // リクエスト
      var reqObj = {}
      reqObj.opId = this.opId
      reqObj.opName = this.opNameForm
      reqObj.groupId = this.selectedGroups

      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/operator/update', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.$bvModal.show('md-confirm')
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          alert(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    back: function () {
      var searchFlg = 1
      var path = '/usermente'
      this.$router.push({ path: path, query: {searchFlg: [searchFlg], searchOpId: [this.searchOpId], searchMailAddress: [this.searchMailAddress], searchOpName: [this.searchOpName]} })
    },
    registConfirm: function () {
      this.$bvModal.hide('md-confirm')
    },
    errConfirm: function () {
      this.$bvModal.hide('md-err')
    },
    // セレクトされたグループの値を取得
    getSelectedGroup: function (selected) {
      this.selectedGroups = []
      var splitlist = selected
      this.selectedGroups = splitlist
    }
  },
  routes: [
    {
      path: '/usermente/:searchFlg/:searchOpId/:searchMailAddress/:searchOpName',
      name: 'usermente',
      components: './Usermente.vue'
    }
  ]
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/UsermenteEdit.vue